// import React from 'react';
import React,{useState} from 'react';
import Select from "react-select";
// import './dashboard.css';
import './utrMail.css';
import axios from 'axios';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import {monthWiseUtrToServer, alcsDetailsToServer} from  '../../../../services/process/migrations/migrationService.js';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, AreaChart, Area, BarChart, Bar } from 'recharts';






function UTRMailer({hidden})
{

    const gridColumnDefs = [
        {field: 'client_id', headerName: 'Client Id', sortable: true, filter: true, resizable: true, width: 130},
        {field: 'client_name', headerName: 'Client Name', sortable: true, filter: true, resizable: true, width: 200},
        {field: 'email_address', headerName: 'Email Address', sortable: true, filter: true, resizable: false, width: 300}
    ]
    const [utrHidden, setUtrHidden] = useState(true);
    const [alcsDetailsChartHidden, setAlcsDetailsChartHidden] = useState(true);
    const [perHidden, setPerHidden] = useState(true);
    const [inputMonth, setInputMonth] = useState(undefined);
    const [mailsCount, setMailsCount] = useState('');
    const [mailsPercent, setMailPercent] = useState('');
    const [utrTypeSelected, setTypeSelected] = useState('');
    const [columnDefs] = useState(gridColumnDefs);
    const [rowData, setRowData] = useState(undefined);
    const [paginationSize] = useState(15);
    const [tableDate, setTableDate] = useState('');
    const [mailTotalCount, setMailTotalCount] = useState('');
    const [mailCount, setMailCount] = useState('');

    console.log("inputMonth", inputMonth);
    console.log("typeSelected", utrTypeSelected);


    function getSetInputMonth(data){
        setInputMonth(data);
        console.log(data);
    }

    function monthWiseutr()
    {
        let payload = {
            month: inputMonth,
            name: utrTypeSelected
        }

        var utrCredentials = monthWiseUtrToServer();
        console.log("brsCredentials", utrCredentials);

        axios.post(utrCredentials[1], payload, utrCredentials[0])
        .then(
            response => {
                console.log("Getting Month Wise utr!!!", response);
                let responseData = response["data"]; 

                console.log("responseData", responseData);
                if (responseData["Status"] === "Success")
                {
                    let utrDetails = responseData["alcsMailCount"];
                    let percentage = responseData["alcsMailsPercentage"]
                    console.log("utrDetails", utrDetails);
                    console.log("percentage", percentage);
                    // let utrPendingDetails = responseData["utrPendingReports"];
                   
                    // setutrProcessedReport(utrDetails["data"]);
                    // setutrPendingReport(utrPendingDetails["data"]);
                    setMailsCount(utrDetails["data"]);
                    setMailPercent(percentage["data"][0]["percentage"]);
                    setMailTotalCount(percentage["data"][0]["total_count"]);
                    setMailCount(percentage["data"][0]["count"]);
                    if (utrTypeSelected === "ALCS Mails Sent To Clients"){
                        setUtrHidden(false);
                        setPerHidden(true);
                    }
                    else if (utrTypeSelected === "ALCS Mails Sent To Clients Percentage"){
                        console.log("hiiii")
                        setUtrHidden(true);
                        setPerHidden(false);
                    }
                    
                    setAlcsDetailsChartHidden(true);
                

                }
            }
            
        ).catch(
            error => {
                console.log("Error", error);
                alert("Error in Getting UTR Details!!!");
            }
        );
    };


    const handleClick = () => {
    const email = 'rajeev.bharadwaj@teamlease.com';
    const password = 'rajeev@1234$';

    const loginUrl = `http://172.16.40.14:3000/1/`;

    // Open the login page with query parameters in a new tab
    window.open(loginUrl, '_blank');
};



    function barChartOnClick(e){
        const date = e.date
        let payload = {
            month: inputMonth,
            date: date,
            name: "ALCS Mails Sent To Clients Details"
        }

        var alcsDetails = alcsDetailsToServer();
        // console.log("brsCredentials", brsCredentials);
        var tableDate = inputMonth + "-" + date
        console.log("tableDate", tableDate);
        setTableDate(tableDate);

        axios.post(alcsDetails[1], payload, alcsDetails[0])
        .then(
            response => {
                console.log("Getting Approved ALCS Details!!!", response);
                let responseData = response["data"]; 
                console.log("responseData", responseData);
                if (responseData["Status"] === "Success")
                {
                    let alcsDetails = responseData["alcsMailDetails"];
                    // let brsDetails = responseData["brsCount"]; 
                    
                    // sessionStorage.setItem("userCredentials", JSON.stringify(userCredentials));
                    // navigate(userCredentials["config"]["default_page"]);
                    console.log("alcsDetails", alcsDetails);
                    setRowData(alcsDetails["data"]);
                    setAlcsDetailsChartHidden(false);
                    // setApproverName(approverDetails["data"][0]["approved_by"]);
                    // setApprovedOn(approverDetails["data"][0]["approved_date"]);
                    // if (approverDetails["data"].length > 0){
                    //     setApproverHidden(false);
                    // }
                    // else{
                    //     setApproverHidden(true);
                    // }
                        
                    // getBankList();
                }
            }
        ).catch(
            error => {
                console.log("Error", error);
                alert("Error in Getting Alcs Details!!!");
            }
        );
    };

    return (
            <div hidden={hidden}>
            <div className="utrchartbox1">
                <div className="utrchart-box-layer">
                    <table style={{width:"60%"}}>
                    
                        <tbody>
                            <tr>
                                <td className="utraddcontracttext">Month</td>
                                <td>:</td>
                                <td><input type="month" name="" onChange={(e) => {setInputMonth(e.target.value)}}/></td>
                               
                                <td className="utraddcontracttext">Choose type</td>
                                <td>:</td>
                                <td>
                                    <select style={{padding:"4px 16px"}}
                                    onChange={(e) => {setTypeSelected(e.target.value)}}>
                                        <option>Select Type:</option>
                                        <option value="ALCS Mails Sent To Clients">Mails Sent</option>
                                        <option value="ALCS Mails Sent To Clients Percentage">Mails Sent Percentage</option>
                                        {/* <option value="3">Resent Mail</option> */}
                                    
                                    </select>
                                </td>
                                
                                <td><button style={{textAlign: "center",  border: ".1px solid #000055", color: "#ffffff", padding:"4px 16px", borderRadius: "15px", backgroundColor: "#024f9d"}} onClick={monthWiseutr}>
                                    Search
                                </button>&nbsp;</td>
                                <td><button style={{textAlign: "center",  border: ".1px solid #000055", color: "#ffffff", padding:"4px 16px", borderRadius: "15px", backgroundColor: "#024f9d" }} onClick={handleClick}>
                                    Go
                                </button>&nbsp;</td>

                            </tr>
                            
                        </tbody>
                    
                    </table>
                </div>
            </div>

            <div className="utrchartbox">
               <div className='utrrecentOrders' hidden = {utrHidden}>
                {/* <h3>idjifj</h3> */}
                <div className="popup-link">
                
                </div>
                <a href="#popup1">
                    <BarChart width={750} height={350} data={mailsCount} style={{marginLeft:"159px", padding:"1%", textAlign: "center"}} >
                        <Bar dataKey="count" fill="#0A2352" barSize={85} onClick={barChartOnClick} />
                        {/* <CartesianGrid stroke="#ccc" /> */}
                        <XAxis dataKey="date" />
                        <YAxis dataKey="count"/>
                        
                        <Tooltip  cursor={false} color="black"/>
                    </BarChart>
                </a>
                </div>
            
                <div id="popup1" className="popup-container">
                <div className="popup-content">
                    <a href="#" className="close">&times;</a>
                    <h4 style={{marginLeft: "30%"}} >Client Details For The Date - {tableDate}</h4>  
                    <div className="ag-theme-balham alcsDetails" hidden = {alcsDetailsChartHidden}>
                                {/* <input type="text" id="filter-text-box" placeholder="Filter..." onInput={onFilterTextBoxChanged}/> */}

                    <AgGridReact
                        columnDefs = {columnDefs}
                        rowData = {rowData}
                        paginationPageSize = {paginationSize}
                        pagination = {true}
                        animateRows = {true}
                        search={true}
                    ></AgGridReact>
                </div>

                </div>
               </div>
                
                <div className='perRecentOrders' hidden = {perHidden}>
                <h4 style={{marginLeft: "30%"}} >Total Number Of Clients - {mailTotalCount}</h4>
                <h4 style={{marginLeft: "30%"}} >Number Of Clients Mail Sent - {mailCount}</h4>
                <h4 style={{marginLeft: "30%"}} >Mail Sent Percentage - {mailsPercent}%</h4>
                {/* <h3>idjifj</h3> */}
                    {/* <LineChart width={750} height={350} data={mailsPercent} style={{marginLeft:"159px", padding:"1%", textAlign: "left"}} >
                        <Line dataKey="percentage" fill="grey" barSize={85}/>
                        <XAxis dataKey="Date" />
                        <YAxis dataKey="Percentage"/>
                    </LineChart> */}
                </div>
            </div>   
        </div>
    );
}

export default  UTRMailer;